import AnchorTarget from "./AnchorTarget";

const AnchorTargetWithProps = ({ blok }) => {
  return <AnchorTarget targetId={blok.targetId} />;
};

export default AnchorTargetWithProps;
